export enum Platform {
  EVM = 'evm',
  SVM = 'svm',
}
